import { useContext, useState } from 'react';

import { LeadCreation, NotificationType } from 'shared/topchef.types'
import api from "shared/topchef-api-places";
import { useOutletContext } from 'react-router';
import { PlaceOutletContextType } from '../home/PlacesHome';
import { NotificationContext } from 'shared/NotificationContext'
import { useTranslation } from 'react-i18next';

type ShareLeadWithAiProps  = {
  initLeadCreationInfo: (extractedLead: LeadCreation) => void;
};


const ShareLeadWithAi = ({ initLeadCreationInfo }: ShareLeadWithAiProps) => {
  const { t } = useTranslation();

  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();
  const [leadDescription, setLeadDescription] = useState<string>('');
  const [isProcessing, setProcessing] = useState<boolean>(false);

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;




  const createPublicLeadWithAI = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setProcessing(true);
    
    try {
      const leadCreation = await api.extractPublicLeadWithAI(loggedInPlace!.id, leadDescription);
      initLeadCreationInfo(leadCreation);
      triggerNotification({type: NotificationType.information, message : t('shareLeadWithAi.successNotif')});
    } catch (error: any) {
      const newError = new Error(t('apiErrors.analyzeWithAi', { details: error.message }) as string);
      triggerNotification({type: NotificationType.error, message : `${newError.message}`});
    } 
    finally {
      setProcessing(false);
    }
  };


  const handleDescriptionChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    event.preventDefault();
    const value = event.target.value;
    setLeadDescription(value);
  };


  return (
    
    <div className="container p-0 m-0 pt-5 mt-5 col-md-5 order-md-2 justify-content-end d-flex">
      <div className="col-md-10">
        <div id="ia_assistance">
            <form onSubmit={createPublicLeadWithAI}>              
              <div>
                    <textarea className="form-control" data-testid="raw-input" onChange={handleDescriptionChange} rows={9} placeholder={String(t('shareLeadWithAi.placeholder'))} required name="description" ></textarea>
              </div>
              <div className="text-center mt-3">
                {isProcessing === false &&
                  <>
                    <button type="submit" className="btn btn-primary ia-button">{t('shareLeadWithAi.submit')}</button>
                  </>
                }
                {isProcessing && 
                  <>
                    <button type="submit" className="btn btn-primary" disabled>
                      <span>{t('shareLeadWithAi.processing')}</span>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                  </>
                }
              </div>
            </form>
          </div>
        </div>
      </div>

  );

}

export default ShareLeadWithAi;

